import React, { forwardRef } from 'react';
interface CheckboxProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string;
  error?: string;
}
export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(({
  label,
  error,
  className,
  ...props
}, ref) => {
  return <div className={className} data-id="element-453">
        <label className="flex items-start space-x-3 cursor-pointer group" data-id="element-454">
          <div className="relative flex items-center mt-0.5" data-id="element-455">
            <input type="checkbox" className="peer h-5 w-5 appearance-none rounded border border-gray-300 checked:border-navy checked:bg-navy focus:outline-none focus:ring-2 focus:ring-navy focus:ring-offset-1" ref={ref} {...props} data-id="element-456" />
            <svg className="pointer-events-none absolute h-5 w-5 text-white opacity-0 peer-checked:opacity-100" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" data-id="element-457">
              <polyline points="20 6 9 17 4 12" data-id="element-458"></polyline>
            </svg>
          </div>
          <span className="text-sm text-gray-700 group-hover:text-navy transition-colors select-none" data-id="element-459">
            {label} {props.required && <span className="text-red-500" data-id="element-460">*</span>}
          </span>
        </label>
        {error && <p className="mt-1 text-xs text-red-500 ml-8" data-id="element-461">{error}</p>}
      </div>;
});
Checkbox.displayName = 'Checkbox';